import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onVirtualPageViewEvent,
  removeVirtualPageViewEvent,
} from '@shared/event/events/virtual-page-view'

const initVirtualPageViewEvents = (Analytics: GooglePlugin) => {
  const virtualPageViewToken = onVirtualPageViewEvent(
    ({
      url,
      pageType,
      version,
      currency,
      customerEmail,
      internalTraffic,
      contentType,
      productId,
      productName,
      productPrice,
      productSku,
      stock,
      store,
      system,
      transactionAffiliation,
      transactionCurrency,
      transactionPayment,
      transactionDate,
      transactionEntity,
      transactionTax,
      transactionId,
      transactionProducts,
      transactionProductsSkus,
      transactionShipping,
      transactionSubtotal,
      transactionTotal,
      transactionTotalWithoutShippingAmount,
      voucherCode,
    }) => {
      Analytics.event({
        event: 'vpv_general',
        vpv_url: url,
        pageType,
        version,
        currency,
        customerEmail,
        internalTraffic,
        contentType,
        productId,
        productName,
        productPrice,
        productSku,
        stock,
        store,
        system,
        transactionAffiliation,
        transactionCurrency,
        transactionPayment,
        transactionDate,
        transactionEntity,
        transactionTax,
        transactionId,
        transactionProducts: transactionProducts || [],
        transactionProductsSkus: transactionProductsSkus || [],
        transactionProductsQuantity:
          transactionProducts?.reduce(
            (sum, transactionProduct) => (sum += transactionProduct.quantity),
            0
          ) || 0,
        transactionShipping,
        transactionSubtotal,
        transactionTotal,
        transactionTotalWithoutShippingAmount,
        voucherCode,
      })
    }
  )

  return () => {
    removeVirtualPageViewEvent(virtualPageViewToken)
  }
}

export default initVirtualPageViewEvents
